import { userRoles } from "modules/common";

export const findUserRoleByLabel = (label: string) =>
  Object.values(userRoles).find((t) => t.label === label);
